import React from 'react';
import HTMLFlipBook from 'react-pageflip';

const Page = React.forwardRef((props, ref) => {
    return (
        <div className="demoPage" ref={ref}>
            <img src={props.image} alt="" style={{width: "100%", height: "100%"}} />
        </div>
    );
});

function Flipbook(props) {
    const { images } = props;

    return (
        <HTMLFlipBook width={500} height={700} showCover={true}>
            {images.map((image, index) => (
                <Page key={index} image={image} />
            ))}
        </HTMLFlipBook>
    );
}

export default Flipbook;
